// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const componentRoutes = [
  {
    path: 'all',
    loadChildren: () => import('./sink/sink.routing').then(m => m.storyRoutes),
  },
  {
    path: 'anchor-scroll',
    loadChildren: () =>
      import('./anchor-scroll/anchor-scroll-stories.module').then(
        m => m.AnchorScrollStoriesModule,
      ),
  },
  {
    path: 'animated-svg',
    loadChildren: () =>
      import('./animated-svg/animated-svg-stories.module').then(
        m => m.AnimatedSvgStoriesModule,
      ),
  },
  {
    path: 'annotation-indicator',
    loadChildren: () =>
      import('./annotation-indicator/annotation-indicator-stories.module').then(
        m => m.AnnotationIndicatorStoriesModule,
      ),
  },
  {
    path: 'badge',
    loadChildren: () =>
      import('./badge/badge-stories.module').then(m => m.BadgeStoriesModule),
  },
  {
    path: 'banner-alert',
    loadChildren: () =>
      import('./banner-alert/banner-alert-stories.module').then(
        m => m.BannerAlertStoriesModule,
      ),
  },
  {
    path: 'banner-announcement',
    loadChildren: () =>
      import('./banner-announcement/banner-announcement-stories.module').then(
        m => m.BannerAnnouncementStoriesModule,
      ),
  },
  {
    path: 'banner-upsell',
    loadChildren: () =>
      import('./banner-upsell/banner-upsell-stories.module').then(
        m => m.BannerUpsellStoriesModule,
      ),
  },
  {
    path: 'breadcrumbs',
    loadChildren: () =>
      import('./breadcrumbs/breadcrumbs-stories.module').then(
        m => m.BreadcrumbsStoriesModule,
      ),
  },
  {
    path: 'button',
    loadChildren: () =>
      import('./button/button-stories.module').then(m => m.ButtonStoriesModule),
  },
  {
    path: 'callout',
    loadChildren: () =>
      import('./callout/callout-stories.module').then(
        m => m.CalloutStoriesModule,
      ),
  },
  {
    path: 'camera-input',
    loadChildren: () =>
      import('./camera-input/camera-input-stories.module').then(
        m => m.CameraInputStoriesModule,
      ),
  },
  {
    path: 'card-list',
    loadChildren: () =>
      import('./card-list/card-list-stories.module').then(
        m => m.CardListStoriesModule,
      ),
  },
  {
    path: 'card',
    loadChildren: () =>
      import('./card/card-stories.module').then(m => m.CardStoriesModule),
  },
  {
    path: 'carousel',
    loadChildren: () =>
      import('./carousel/carousel-stories.module').then(
        m => m.CarouselStoriesModule,
      ),
  },
  {
    path: 'chart',
    loadChildren: () =>
      import('./chart/chart-stories.module').then(m => m.ChartStoriesModule),
  },
  {
    path: 'checkbox-card',
    loadChildren: () =>
      import('./checkbox-card/checkbox-card-stories.module').then(
        m => m.CheckboxCardStoriesModule,
      ),
  },
  {
    path: 'checkbox',
    loadChildren: () =>
      import('./checkbox/checkbox-stories.module').then(
        m => m.CheckboxStoriesModule,
      ),
  },
  {
    path: 'container',
    loadChildren: () =>
      import('./container/container-stories.module').then(
        m => m.ContainerStoriesModule,
      ),
  },
  {
    path: 'countdown-timer',
    loadChildren: () =>
      import('./countdown-timer/countdown-timer-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'currency-input',
    loadChildren: () =>
      import('./currency-input/currency-input-stories.module').then(
        m => m.CurrencyInputStoriesModule,
      ),
  },
  {
    path: 'display-card',
    loadChildren: () =>
      import('./display-card/display-card-stories.module').then(
        m => m.DisplayCardStoriesModule,
      ),
  },
  {
    path: 'drawer',
    loadChildren: () =>
      import('./drawer/drawer-stories.module').then(m => m.DrawerStoriesModule),
  },
  {
    path: 'dropdown-filter',
    loadChildren: () =>
      import('./dropdown-filter/dropdown-filter-stories.module').then(
        m => m.DropdownFilterStoriesModule,
      ),
  },
  {
    path: 'emoji-picker',
    loadChildren: () =>
      import('./emoji-picker/emoji-picker-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'file-display',
    loadChildren: () =>
      import('./file-display/file-display-stories.module').then(
        m => m.FileDisplayStoriesModule,
      ),
  },
  {
    path: 'file-select',
    loadChildren: () =>
      import('./file-select/file-select-stories.module').then(
        m => m.FileSelectStoriesModule,
      ),
  },
  {
    path: 'file-viewer',
    loadChildren: () =>
      import('./file-viewer/file-viewer-stories.module').then(
        m => m.FileViewerStoriesModule,
      ),
  },
  {
    path: 'flag',
    loadChildren: () =>
      import('./flag/flag-stories.module').then(m => m.FlagStoriesModule),
  },
  {
    path: 'floating-action',
    loadChildren: () =>
      import('./floating-action/floating-action-stories.module').then(
        m => m.FloatingActionStoriesModule,
      ),
  },
  {
    path: 'focus',
    loadChildren: () =>
      import('./focus/focus-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'form-save',
    loadChildren: () =>
      import('./form-save/form-save-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'gallery-grid',
    loadChildren: () =>
      import('./gallery-grid/gallery-grid-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'gallery-mosaic',
    loadChildren: () =>
      import('./gallery-mosaic/gallery-mosaic-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'generic-error',
    loadChildren: () =>
      import('./generic-error/generic-error-stories.module').then(
        m => m.GenericErrorStoriesModule,
      ),
  },
  {
    path: 'grid',
    loadChildren: () =>
      import('./grid/grid-stories.module').then(m => m.GridStoriesModule),
  },
  {
    path: 'highlight-text',
    loadChildren: () =>
      import('./highlight-text/highlight-text-stories.module').then(
        m => m.HighlightTextStoriesModule,
      ),
  },
  {
    path: 'highlight',
    loadChildren: () =>
      import('./highlight/highlight-stories.module').then(
        m => m.HighlightStoriesModule,
      ),
  },
  {
    path: 'hr',
    loadChildren: () =>
      import('./hr/hr-stories.module').then(m => m.HrStoriesModule),
  },
  {
    path: 'icon',
    loadChildren: () =>
      import('./icon/icon-stories.module').then(m => m.IconStoriesModule),
  },
  {
    path: 'image-cropper',
    loadChildren: () =>
      import('./image-cropper/image-cropper-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'infinite-scroll',
    loadChildren: () =>
      import('./infinite-scroll/infinite-scroll-stories.module').then(
        m => m.InfiniteScrollStoriesModule,
      ),
  },
  {
    path: 'input',
    loadChildren: () =>
      import('./input/input-stories.module').then(m => m.InputStoriesModule),
  },
  {
    path: 'label',
    loadChildren: () =>
      import('./label/label-stories.module').then(m => m.LabelStoriesModule),
  },
  {
    path: 'link',
    loadChildren: () =>
      import('./link/link-stories.module').then(m => m.LinkStoriesModule),
  },
  {
    path: 'list',
    loadChildren: () =>
      import('./list/list-stories.module').then(m => m.ListStoriesModule),
  },
  {
    path: 'loading-text',
    loadChildren: () =>
      import('./loading-text/loading-text-stories.module').then(
        m => m.LoadingTextStoriesModule,
      ),
  },
  {
    path: 'location-input',
    loadChildren: () =>
      import('./location-input/location-input-stories.module').then(
        m => m.LocationInputStoriesModule,
      ),
  },
  {
    path: 'logo',
    loadChildren: () =>
      import('./logo/logo-stories.module').then(m => m.LogoStoriesModule),
  },
  {
    path: 'map',
    loadChildren: () =>
      import('./map/map-stories.module').then(m => m.MapStoriesModule),
  },
  {
    path: 'margin',
    loadChildren: () =>
      import('./margin/margin-stories.module').then(m => m.MarginStoriesModule),
  },
  {
    path: 'media-viewer',
    loadChildren: () =>
      import('./media-viewer/media-viewer-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'modal',
    loadChildren: () =>
      import('./modal/modal-stories.module').then(m => m.ModalStoriesModule),
  },
  {
    path: 'more-options',
    loadChildren: () =>
      import('./more-options/more-options-stories.module').then(
        m => m.MoreOptionsStoriesModule,
      ),
  },
  {
    path: 'multi-select',
    loadChildren: () =>
      import('./multi-select/multi-select-stories.module').then(
        m => m.MultiSelectStoriesModule,
      ),
  },
  {
    path: 'multiple-location-input',
    loadChildren: () =>
      import(
        './multiple-location-input/multiple-location-input-stories.module'
      ).then(m => m.MultipleLocationInputStoriesModule),
  },
  {
    path: 'new-feature-tag',
    loadChildren: () =>
      import('./new-feature-tag/new-feature-tag-stories.module').then(
        m => m.NewFeatureTagStoriesModule,
      ),
  },
  {
    path: 'online-indicator',
    loadChildren: () =>
      import('./online-indicator/online-indicator-stories.module').then(
        m => m.OnlineIndicatorStoriesModule,
      ),
  },
  {
    path: 'page-layout',
    loadChildren: () =>
      import('./page-layout/page-layout-stories.module').then(
        m => m.PageLayoutStoriesModule,
      ),
  },
  {
    path: 'pagination',
    loadChildren: () =>
      import('./pagination/pagination-stories.module').then(
        m => m.PaginationStoriesModule,
      ),
  },
  {
    path: 'phone-input',
    loadChildren: () =>
      import('./phone-input/phone-input-stories.module').then(
        m => m.PhoneInputStoriesModule,
      ),
  },
  {
    path: 'picture',
    loadChildren: () =>
      import('./picture/picture-stories.module').then(
        m => m.PictureStoriesModule,
      ),
  },
  {
    path: 'progress-bar',
    loadChildren: () =>
      import('./progress-bar/progress-bar-stories.module').then(
        m => m.ProgressBarStoriesModule,
      ),
  },
  {
    path: 'progress-steps',
    loadChildren: () =>
      import('./progress-steps/progress-steps-stories.module').then(
        m => m.ProgressStepsStoriesModule,
      ),
  },
  {
    path: 'pull-refresh',
    loadChildren: () =>
      import('./pull-refresh/pull-refresh-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'radio',
    loadChildren: () =>
      import('./radio/radio-stories.module').then(m => m.RadioStoriesModule),
  },
  {
    path: 'rating',
    loadChildren: () =>
      import('./rating/rating-stories.module').then(m => m.RatingStoriesModule),
  },
  {
    path: 'relative-time',
    loadChildren: () =>
      import('./relative-time/relative-time-stories.module').then(
        m => m.RelativeTimeStoriesModule,
      ),
  },
  {
    path: 'ribbon',
    loadChildren: () =>
      import('./ribbon/ribbon-stories.module').then(m => m.RibbonStoriesModule),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./search/search-stories.module').then(m => m.SearchStoriesModule),
  },
  {
    path: 'select',
    loadChildren: () =>
      import('./select/select-stories.module').then(m => m.SelectStoriesModule),
  },
  {
    path: 'share-buttons',
    loadChildren: () =>
      import('./share-buttons/share-buttons-stories.module').then(
        m => m.ShareButtonsStoriesModule,
      ),
  },
  {
    path: 'share-link',
    loadChildren: () =>
      import('./share-link/share-link-stories.module').then(
        m => m.ShareLinkStoriesModule,
      ),
  },
  {
    path: 'slider',
    loadChildren: () =>
      import('./slider/slider-stories.module').then(m => m.SliderStoriesModule),
  },
  {
    path: 'smart-textarea',
    loadChildren: () =>
      import('./smart-textarea/smart-textarea-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'social-buttons',
    loadChildren: () =>
      import('./social-buttons/social-buttons-stories.module').then(
        m => m.SocialButtonsStoriesModule,
      ),
  },
  {
    path: 'spinner',
    loadChildren: () =>
      import('./spinner/spinner-stories.module').then(
        m => m.SpinnerStoriesModule,
      ),
  },
  {
    path: 'split-button',
    loadChildren: () =>
      import('./split-button/split-button-stories.module').then(
        m => m.SplitButtonStoriesModule,
      ),
  },
  {
    path: 'sticky-footer',
    loadChildren: () =>
      import('./sticky-footer/sticky-footer-stories.module').then(
        m => m.StickyFooterStoriesModule,
      ),
  },
  {
    path: 'table',
    loadChildren: () =>
      import('./table/table-stories.module').then(m => m.TableStoriesModule),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./tabs/tabs-stories.module').then(m => m.TabsStoriesModule),
  },
  {
    path: 'tag-status',
    loadChildren: () =>
      import('./tag-status/tag-status-stories.module').then(
        m => m.TagStatusStoriesModule,
      ),
  },
  {
    path: 'tag',
    loadChildren: () =>
      import('./tag/tag-stories.module').then(m => m.TagStoriesModule),
  },
  {
    path: 'tailwind-text',
    loadChildren: () =>
      import('./tailwind-text/tailwind-text-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'textarea',
    loadChildren: () =>
      import('./textarea/textarea-stories.module').then(
        m => m.TextareaStoriesModule,
      ),
  },
  {
    path: 'thumbnail-viewer',
    loadChildren: () =>
      import('./thumbnail-viewer/thumbnail-viewer-stories.module').then(
        m => m.ThumbnailViewerStoriesModule,
      ),
  },
  {
    path: 'toast-alert',
    loadChildren: () =>
      import('./toast-alert/toast-alert-stories.module').then(
        m => m.ToastAlertStoriesModule,
      ),
  },
  {
    path: 'toggle-buttons',
    loadChildren: () =>
      import('./toggle-buttons/toggle-buttons-stories.module').then(
        m => m.ToggleButtonsStoriesModule,
      ),
  },
  {
    path: 'toggle',
    loadChildren: () =>
      import('./toggle/toggle-stories.module').then(m => m.ToggleStoriesModule),
  },
  {
    path: 'tooltip',
    loadChildren: () =>
      import('./tooltip/tooltip-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'unread-indicator',
    loadChildren: () =>
      import('./unread-indicator/unread-indicator-stories.module').then(
        m => m.UnreadIndicatorStoriesModule,
      ),
  },
  {
    path: 'user-avatar',
    loadChildren: () =>
      import('./user-avatar/user-avatar-stories.module').then(
        m => m.UserAvatarStoriesModule,
      ),
  },
  {
    path: 'validation-error',
    loadChildren: () =>
      import('./validation-error/validation-error-stories.module').then(
        m => m.ValidationErrorStoriesModule,
      ),
  },
  {
    path: 'video-modal',
    loadChildren: () =>
      import('./video-modal/video-modal-stories.module').then(
        m => m.VideoModalStoriesModule,
      ),
  },
  {
    path: 'video',
    loadChildren: () =>
      import('./video/video-stories.module').then(m => m.VideoStoriesModule),
  },
  {
    path: 'view-header',
    loadChildren: () =>
      import('./view-header/view-header-stories.module').then(
        m => m.ViewHeaderStoriesModule,
      ),
  },
  {
    path: 'widget',
    loadChildren: () =>
      import('./widget/widget-stories.module').then(m => m.WidgetStoriesModule),
  },
];
